import {Button, Form, Input, Select} from "antd";
import DatePicker from "../../../core/components/DatePicker";
import "../../../core/style/grid-filter.css";
import {useTranslation} from "react-i18next";
import {useDataGrid} from "../../../core/components/data-grid/DataGridContext";
import {useRef, useState} from "react";
import {DATE_OPTIONS, getBeginStr, getDateFromNow, getEndStr} from "../../../core/utils/date-utils";
import HospitalSelectBox from "../../hospital/HospitalSelectBox";
import ModalitySelectBox from "../../modality/ModalitySelectBox";
import KosStatusEnum from "../../../enums/KosStatusEnum";
import {parseListInput} from "../../../core/utils/parse-list-input";

export default function TeletipFilter()
{
    const {t} = useTranslation();
    const {onFilterPageSort} = useDataGrid();
    const formRef = useRef();

    const getDefaultDate = () => {
        const date = getDateFromNow(DATE_OPTIONS.TODAY);
        return [date.start, date.end]
    }

    const date = getDefaultDate();

    const reset = () => {
        window.location.reload()
    }

    const filter = (form) => {
        onFilterPageSort({
            filter: {
                ...form,
                studyReceivedDateTimeBegin: getBeginStr(form.studyReceivedDateTimeBegin),
                studyReceivedDateTimeEnd: getEndStr(form.studyReceivedDateTimeEnd),
                studyIdList: parseListInput(form.studyIdList),
                patientIdList: parseListInput(form.patientIdList),
                accessionNumberList: parseListInput(form.accessionNumberList),
            }
        })
    }

    // Liste kutularında Enter arama yapar, Shift+Enter alt satıra geçer.
    const submitOnEnter = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            formRef.current?.submit();
        }
    }

    return (
        <>
            <Form
                ref={formRef}
                onFinish={filter}
                layout={'vertical'}
                // Grid üstündeki yatay filtre kartında durur (bkz. GridFilterCard).
                className={'grid-filter-form grid-filter-inline'}
                initialValues={{
                    studyReceivedDateTimeBegin: date[0],
                    studyReceivedDateTimeEnd: date[1],
                    statusList: []
                }}
            >
                <Form.Item
                    label={t('Date')}
                    name="studyReceivedDateTimeBegin"
                    className={'grid-filter-narrow'}
                >
                    <DatePicker showToday={false} style={{width: '100%'}} />
                </Form.Item>
                <Form.Item
                    label={' '}
                    name="studyReceivedDateTimeEnd"
                    className={'grid-filter-narrow'}
                >
                    <DatePicker showToday={false} style={{width: '100%'}} />
                </Form.Item>
                {/* Liste kutuları yatay kartta tek satır başlar, yapıştırılan liste kadar (en çok 4 satır)
                    uzar. Ayırma açıklaması satırı şişirmesin diye alt metin yerine etiket ipucunda. */}
                <Form.Item
                    label={t('Study Ids')}
                    name={'studyIdList'}
                    tooltip={t('Separate values with comma, space or new line')}
                >
                    <Input.TextArea autoSize={{minRows: 1, maxRows: 4}} allowClear onKeyDown={submitOnEnter} placeholder={t('e.g.') + " 10023, 10024 10025"} />
                </Form.Item>
                <Form.Item
                    label={t('Patient Ids')}
                    name={'patientIdList'}
                    tooltip={t('Separate values with comma, space or new line')}
                >
                    <Input.TextArea autoSize={{minRows: 1, maxRows: 4}} allowClear onKeyDown={submitOnEnter} placeholder={t('e.g.') + " 12345678901, 98765432109"} />
                </Form.Item>
                <Form.Item
                    label={t('Accession Numbers')}
                    name={'accessionNumberList'}
                    tooltip={t('Separate values with comma, space or new line')}
                >
                    <Input.TextArea autoSize={{minRows: 1, maxRows: 4}} allowClear onKeyDown={submitOnEnter} placeholder={t('e.g.') + " 6006169198, 6006169199"} />
                </Form.Item>
                <Form.Item
                    label={t('Patient Name')}
                    name={'patientName'}
                >
                    <Input allowClear />
                </Form.Item>
                <Form.Item
                    label={t('Modality')}
                    name={'modalities'}
                >
                    <ModalitySelectBox />
                </Form.Item>
                <Form.Item
                    label={t('Hospitals')}
                    name="hospitalIdList"
                >
                    <HospitalSelectBox />
                </Form.Item>
                <Form.Item
                    label={t('Status')}
                    name="statusList"
                >
                    <Select
                        mode={'multiple'}
                        options={
                            Object.keys(KosStatusEnum).map(key => ({
                                label: t(`${key}`),
                                value: KosStatusEnum[key]
                            }))
                        }
                    />
                </Form.Item>
                <Form.Item className={'grid-filter-actions'}>
                    <Button type={'primary'} htmlType="submit" >{t('Search')}</Button>
                    <Button onClick={reset}>{t('Reset')}</Button>
                </Form.Item>
            </Form>
        </>
    )
}
